'use strict';

function reverseString(str) {
    return str.split('').reverse().join('');
}

export default class ObfEmlHandler {
    constructor() {
        this.parse();

        document.addEventListener(
            'w.MapHandler.clickMarker',
            (event) => {
                this.parse();
            },
            false
        );
    }

    parse() {
        this.elements = document.querySelectorAll('[data-w-obf-eml]');
        for (const element of this.elements) {
            const email =
                reverseString(element.getAttribute('data-w-obf-eml-p')) +
                reverseString(element.getAttribute('data-w-obf-eml-s'));
            const emailText =
                reverseString(element.getAttribute('data-w-obf-eml-p')) +
                '@<wbr />' +
                reverseString(element.getAttribute('data-w-obf-eml-s'));

            const anchor = document.createElement('a');
            anchor.classList = element.classList;
            anchor.setAttribute('href', 'mailto:' + email);
            anchor.innerHTML = emailText;
            element.parentNode.replaceChild(anchor, element);
        }
    }
}
